import React from "react";
import { useTranslation } from "react-i18next";
import type { IEmailMarketingTemplateListItem } from "api/rpc/2024-04/facilityAdmin/marketing/emailMarketingTemplatesTypes";
import {
  isEmailBuilderBlankSystemTemplate,
  resolveEmailBuilderTemplateCardPreviewSrc,
} from "../emailBuilderCampaignEntry";
import "./emailBuilderTemplatePicker.scss";

type TEmailBuilderTemplatePickerCardProps = {
  template: IEmailMarketingTemplateListItem;
  disabled: boolean;
  onSelect: (templateId: number) => void;
};

export function EmailBuilderTemplatePickerCard(props: TEmailBuilderTemplatePickerCardProps) {
  const { t } = useTranslation();
  const previewSrc = resolveEmailBuilderTemplateCardPreviewSrc(props.template);
  const isBlankIllustration = isEmailBuilderBlankSystemTemplate(props.template);

  return (
    <button
      type="button"
      className="email-builder-template-picker-card"
      disabled={props.disabled}
      aria-label={t("Select {{name}}", { name: props.template.name })}
      data-email-builder-template-id={props.template.id}
      onClick={() => props.onSelect(props.template.id)}
    >
      <div
        className={
          isBlankIllustration
            ? "email-builder-template-picker-card__preview email-builder-template-picker-card__preview--blank"
            : "email-builder-template-picker-card__preview"
        }
        aria-hidden="true"
      >
        {previewSrc != null ? (
          <img
            className={
              isBlankIllustration
                ? "email-builder-template-picker-card__image email-builder-template-picker-card__image--blank"
                : "email-builder-template-picker-card__image"
            }
            src={previewSrc}
            alt=""
            loading="lazy"
          />
        ) : (
          <div className="email-builder-template-picker-card__placeholder">
            <span className="email-builder-template-picker-card__placeholder-label">
              {t("No preview")}
            </span>
          </div>
        )}
      </div>
      <div className="email-builder-template-picker-card__title" title={props.template.name}>
        {props.template.name}
      </div>
    </button>
  );
}
